import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { INotification, notification } from "infrastructure/notification";
import { actionProcessing } from "infrastructure/store";
import { getScreenExtraReducers } from "ui/app";
import { displayMessages } from "ui/screens/translation-managers/translation-managers.localization";

import { IMessageTranslationState, getMessageTranslationsInitialState, IMessageTranslation } from "./MessageTranslations.state";

const initialState = getMessageTranslationsInitialState();

export const messageTranslations = createSlice({
  initialState: initialState,
  name: "messageTranslations",
  reducers: {
    loadMessageTranslations: (state: IMessageTranslationState, _: PayloadAction<string>) => {
      return { ...state, isLoading: true };
    },
    loadMessageTranslationsCompleted: (state: IMessageTranslationState, action: PayloadAction<IMessageTranslation[]>): IMessageTranslationState => {
      return {
        ...state,
        isLoading: false,
        messageTranslations: action.payload,
        notifications: action.payload.length > 0 ? [] : [notification.warning().useMessageId(displayMessages.warn("notFoundMessageTranslations"))]
      };
    },
    loadMessageTranslationsFailed: (state: IMessageTranslationState, action: PayloadAction<INotification>): IMessageTranslationState => {
      return { ...state, isLoading: false, notifications: [action.payload] };
    },
    clearState: actionProcessing.createWithClearNotification(() => {
      return {
        ...initialState
      };
    })
  },
  extraReducers: getScreenExtraReducers<IMessageTranslationState>("notifications", initialState)
});
